module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Theodore Taylor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Theodore Taylor was an American author of more than fifty fiction and nonfiction books for young adult and adult readers. During World War II, he first served as a cadet-AB seaman on a gasoline tanker, then became a naval officer in the Pacific Theater. Taylor published his first book, "), _c('I', [_vm._v("The Magnificent Mitscher")]), _vm._v(", in 1955. His novel "), _c('I', [_vm._v("The Cay ")]), _vm._v("won eleven literary awards, including the Lewis Carroll Shelf Award, and was adapted into a film in 1974. In 2006, Taylor passed away in his beloved “house in the woods” in Laguna Beach, California. He was surrounded by his family, his books, and years of wonderful memories.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VQaPOS/tc-custom/9781504077163.jpg?1702178634939",
      "alt": "This image is the cover for the book H.M.S. Hood vs. Bismarck"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("H.M.S. Hood vs. Bismarck\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An account of the WWII sea battle by the author of "), _c('i', [_vm._v("The Cay")]), _vm._v(": “The story of the Bismarck is one of exciting high adventure, and [Taylor] captures it nicely.” —"), _c('i', [_vm._v("The New York Times")])]), _c('br'), _c('br'), _vm._v(" From the award-winning author, this is a compelling history of the sinking of British battlecruiser H.M.S. "), _c('i', [_vm._v("Hood")]), _vm._v(" in the cold waters of the North Atlantic in 1941. It was a great loss to the Royal Navy and resulted in the deaths of more than fourteen hundred sailors. Soon the Allies were in hot pursuit of the "), _c('i', [_vm._v("Bismarck")]), _vm._v(", the German fleet’s biggest and most fearsome ship."), _c('br'), _c('br'), _vm._v(" The Nazi battleship would meet its end just days after it sank the "), _c('i', [_vm._v("Hood")]), _vm._v("—and this book tells the riveting story of this deadly confrontation at sea.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0